import { baseApi, client } from '../baseApi.ts';

export const voicesEndpoints = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getVoices: builder.query({
			// @ts-ignore
			queryFn: async () => {
				try {
					const response = await client.voices.list();
					return { data: response.data };
				} catch (error) {
					return { error };
				}
			},
			providesTags: ['Voices'],
		}),
	}),
});
